import type { Format } from '../schemas/format';

/**
 * Policy (CX) under CHSSA rules (Article XI §2): four 8-minute constructives each followed by 3 minutes of
 * cross-examination, then four 5-minute rebuttals; 8 minutes of prep per team. Aff speaks first and last.
 * The 2NC and 1NR back to back are the "negative block". (NSDA uses the same times.)
 */
export const POLICY_CHSSA: Format = {
  id: 'policy-chssa',
  version: 1,
  name: 'Policy (CHSSA)',
  event: 'policy',
  ruleset: 'CHSSA',
  sideLabels: ['Aff', 'Neg'],
  teamSize: 2,
  order: 'fixed',
  prepSec: 480,
  graceSec: 10,
  points: { min: 25, max: 30, step: 0.1 },
  extensionRoles: ['final'],
  extensionNote: 'An argument counts at the end if its team carried it into their last rebuttal: the 2AR for Aff, the 2NR for Neg.',
  segments: [
    { id: '1AC', kind: 'speech', role: 'constructive', label: '1st Affirmative Constructive', short: '1AC', durationSec: 480, by: 'first', speakers: [1] },
    { id: 'CX1', kind: 'questioning', role: 'questioning', label: 'Cross-examination of the 1A', short: 'CX', durationSec: 180, by: 'both', speakers: [] },
    { id: '1NC', kind: 'speech', role: 'constructive', label: '1st Negative Constructive', short: '1NC', durationSec: 480, by: 'second', speakers: [1] },
    { id: 'CX2', kind: 'questioning', role: 'questioning', label: 'Cross-examination of the 1N', short: 'CX', durationSec: 180, by: 'both', speakers: [] },
    { id: '2AC', kind: 'speech', role: 'constructive', label: '2nd Affirmative Constructive', short: '2AC', durationSec: 480, by: 'first', speakers: [2] },
    { id: 'CX3', kind: 'questioning', role: 'questioning', label: 'Cross-examination of the 2A', short: 'CX', durationSec: 180, by: 'both', speakers: [] },
    { id: '2NC', kind: 'speech', role: 'constructive', label: '2nd Negative Constructive', short: '2NC', durationSec: 480, by: 'second', speakers: [2] },
    { id: 'CX4', kind: 'questioning', role: 'questioning', label: 'Cross-examination of the 2N', short: 'CX', durationSec: 180, by: 'both', speakers: [] },
    { id: '1NR', kind: 'speech', role: 'rebuttal', label: '1st Negative Rebuttal', short: '1NR', durationSec: 300, by: 'second', speakers: [1] },
    { id: '1AR', kind: 'speech', role: 'rebuttal', label: '1st Affirmative Rebuttal', short: '1AR', durationSec: 300, by: 'first', speakers: [1] },
    { id: '2NR', kind: 'speech', role: 'final', label: '2nd Negative Rebuttal', short: '2NR', durationSec: 300, by: 'second', speakers: [2] },
    { id: '2AR', kind: 'speech', role: 'final', label: '2nd Affirmative Rebuttal', short: '2AR', durationSec: 300, by: 'first', speakers: [2] },
  ],
  sheets: [
    { id: 'case-first', title: '{first} case', owner: 'first', segmentIds: ['1AC', 'CX1', '1NC', 'CX2', '2AC', 'CX3', '2NC', 'CX4', '1NR', '1AR', '2NR', '2AR'] },
    { id: 'case-second', title: '{second} off-case', owner: 'second', segmentIds: ['1NC', 'CX2', '2AC', 'CX3', '2NC', 'CX4', '1NR', '1AR', '2NR', '2AR'] },
  ],
};
